import { render } from "./SelectedItem.vue?vue&type=template&id=508ed2f1"
import script from "./SelectedItem.vue?vue&type=script&lang=js"
export * from "./SelectedItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__